import React, { memo, useCallback, useState } from 'react';
import {
  IMarket,
  deleteMarket as deleteMarketById,
} from '@ui/api/v2/markets.api';
import { EditIcon } from '@ui/components';
import { Modal } from 'antd';
import { replaceSpaceByDash } from '../../utils/helpers';

interface IProps {
  market: IMarket;
  setEditMarket: (market: IMarket) => void;
  onDelete: (id: number) => void;
}

function MarketCard({ market, setEditMarket, onDelete }: IProps) {
  const [showModal, setShowModal] = useState(false);

  const onEditClick = useCallback(() => {
    setEditMarket(market);
  }, [market, setEditMarket]);

  const deleteMarket = useCallback(() => {
    setShowModal(false);
    void deleteMarketById(market.id);
    onDelete(market.id);
  }, [market, onDelete, setShowModal]);

  return (
    <div className="markets__item">
      <span>{replaceSpaceByDash(market.name)}</span>
      <span>{market.city.name}</span>
      <span>{market.address}</span>
      <div className="markets__controls">
        <EditIcon onClick={onEditClick} type="edit" />
        <EditIcon onClick={() => setShowModal(true)} type="remove" />
      </div>
      <Modal
        okButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'danger',
        }}
        cancelButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'primary',
        }}
        okText="Да"
        cancelText="Нет"
        title="Удаление фабрики"
        visible={showModal}
        onOk={deleteMarket}
        onCancel={() => setShowModal(false)}
      >
        <p>Вы уверены, что ходите удалить фабрику {market.name}</p>
      </Modal>
    </div>
  );
}

export default memo(MarketCard);



// WEBPACK FOOTER //
// ./src/components/Markets/MarketCard.tsx